/**
 * EditorBackHeader — the shared top-of-sidebar header used by every editor:
 * a circular Back button next to an accent pill with the editor name centred.
 *
 * Rendered as the first child of the left sidebar's scroll column with
 * order:-100 so it always pins to the top regardless of panel reordering.
 */

import React from 'react';
import { color, font } from './theme';
import { IcChevLeft } from './icons';

export default function EditorBackHeader({ name, onBack }: { name: string; onBack: () => void }) {
  return (
    <div style={rowStyle}>
      <button onClick={onBack} title="Back to Dashboard" style={backBtnStyle}>
        <IcChevLeft size={18} />
      </button>
      <div style={pillStyle}>
        {/* First word bold; any following words (Synth VR / Synth Console) use a
            thinner weight of the same typeface for contrast. */}
        {name.split(' ').map((word, i) => (
          <span key={i} style={{ fontWeight: i === 0 ? 800 : 400, marginLeft: i === 0 ? 0 : '0.35em' }}>
            {word}
          </span>
        ))}
      </div>
    </div>
  );
}

const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 8,
  order: -100,
};

const backBtnStyle: React.CSSProperties = {
  flexShrink: 0,
  width: 38,
  height: 38,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'oklch(0.18 calc(0.026 * var(--tint-c)) var(--tint-h) / 0.5)',
  border: '1px solid oklch(0.62 calc(0.11 * var(--tint-c)) var(--tint-h) / 0.25)',
  color: 'var(--accent)',
  cursor: 'pointer',
};

const pillStyle: React.CSSProperties = {
  flex: 1,
  height: 38,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 999,
  background: 'var(--accent)',
  color: 'oklch(0.14 calc(0.022 * var(--tint-c)) var(--tint-h))',
  fontWeight: 800,
  fontSize: 11,
  letterSpacing: 1,
  textTransform: 'uppercase',
  fontFamily: font.sans,
  boxShadow: '0 0 16px oklch(0.70 calc(0.205 * var(--accent-c)) var(--accent-h) / 0.35)',
};
